import { render, staticRenderFns } from "./TextAreaAutoGrow.vue?vue&type=template&id=6bc76ff2&"
import script from "./TextAreaAutoGrow.vue?vue&type=script&lang=ts&"
export * from "./TextAreaAutoGrow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports